export default function ({ width, stroke }) {
  return (
    <svg
      width={width}
      stroke={stroke}
      viewBox="0 0 20 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.99998 6.52099V10.0304M9.99998 13.5399H10.0088M8.49969 2.01136L1.06846 14.4172C0.915247 14.6826 0.834178 14.9834 0.83332 15.2898C0.832462 15.5962 0.911845 15.8974 1.06357 16.1636C1.2153 16.4298 1.43408 16.6516 1.69815 16.807C1.96222 16.9624 2.26237 17.0459 2.56875 17.0493H17.4312C17.7376 17.0459 18.0377 16.9624 18.3018 16.807C18.5659 16.6516 18.7847 16.4298 18.9364 16.1636C19.0881 15.8974 19.1675 15.5962 19.1666 15.2898C19.1658 14.9834 19.0847 14.6826 18.9315 14.4172L11.5003 2.01136C11.3439 1.75351 11.1236 1.54032 10.8608 1.39237C10.598 1.24441 10.3016 1.16669 9.99998 1.16669C9.6984 1.16669 9.40191 1.24441 9.13912 1.39237C8.87633 1.54032 8.6561 1.75351 8.49969 2.01136Z"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
